import { useState, useCallback } from 'react';
import type { CompanyAnnual } from '@/services/accountService/companyAnnualService';

export interface ValidationErrors {
  periodFrom?: string;
  periodTo?: string;
  lastYearPeriodFrom?: string;
  lastYearPeriodTo?: string;
  auditCertificateId?: string;
}

export function useFormValidation() {
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>({});

  const validateRequiredFields = useCallback((form: CompanyAnnual | null): boolean => {
    if (!form) return false;

    const errors: ValidationErrors = {};

    if (!form.periodFrom) {
      errors.periodFrom = 'Period From is required';
    }
    if (!form.periodTo) {
      errors.periodTo = 'Period To is required';
    }
    if (!form.lastYearPeriodFrom) {
      errors.lastYearPeriodFrom = 'Last Year Period From is required';
    }
    if (!form.lastYearPeriodTo) {
      errors.lastYearPeriodTo = 'Last Year Period To is required';
    }
    if (!form.auditCertificateId || form.auditCertificateId === 0) {
      errors.auditCertificateId = 'Audit Certificate is required';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  }, []);

  const clearValidationErrors = useCallback(() => {
    setValidationErrors({});
  }, []);

  const hasValidationErrors = Object.keys(validationErrors).length > 0;

  return {
    validationErrors,
    validateRequiredFields,
    clearValidationErrors,
    hasValidationErrors,
  };
}
